'use client'
import { NotificationWidget } from '@chaseweb/ui-library/src'
import { useEffect, useState } from 'react'

import { StyledLink } from '@/components'

import { isSupportedBrowser } from './helpers'

const REQUIREMENTS_URL =
  'https://www.chase.com/digital/resources/privacy-security/security/system-requirements'

export const BrowserSupportNotification = ({
  onDismiss,
}: {
  onDismiss: () => void
}) => {
  const [isNotSupportedBrowser, setIsNotSupportedBrowser] =
    useState<boolean>(false)

  const [show, setShow] = useState(true)

  useEffect(() => {
    setIsNotSupportedBrowser(!isSupportedBrowser())
  }, [])

  const handleNotificationClick = () => {
    setShow(false)
    onDismiss()
  }

  if (isNotSupportedBrowser && show) {
    return (
      <div className="tw-container-maxwidth">
        <NotificationWidget.Root show variant="warning">
          <NotificationWidget.Icon aria-label="warning" variant="warning" />
          <NotificationWidget.Content>
            <NotificationWidget.Title>
              You are using a browser that is not supported
            </NotificationWidget.Title>
            <NotificationWidget.Text>
              To enjoy the best experience on Chase.co.uk, be sure your web
              browser and operating system meet our&nbsp;
              <StyledLink
                invertLinkUnderline
                sectionLabel="BannerItem"
                trackingActionLabel={REQUIREMENTS_URL}
                href={REQUIREMENTS_URL}
                target="_blank"
              >
                recommendations
              </StyledLink>
            </NotificationWidget.Text>
          </NotificationWidget.Content>
          <NotificationWidget.CloseButton onClick={handleNotificationClick} />
        </NotificationWidget.Root>
      </div>
    )
  }
  return null
}
